import dayjs from 'dayjs';
import { AccessEventsFilter } from 'graphql/generated/graphqlTypes';
import { DEFAULT_DATE_RANGE_DAYS } from './eventFilterConstants';
import { EventsFilter } from './eventFilterTypes';

/**
 * Builds the API filter from the filter state.
 * Returns `null` when no filter is set, so `apiFilter !== null` is also the "is any filter enabled" check.
 * That keeps the filters sent to the API and the filters shown as active in sync.
 */
export const createEventApiFilter = ({
  access,
  detail,
  dateStart,
  dateEnd,
  user,
  device
}: EventsFilter): AccessEventsFilter | null => {
  const filter: AccessEventsFilter = {};
  if (access) filter.actions = [access];
  if (dateStart || dateEnd) {
    const rangeEnd = dateEnd ?? dayjs();
    filter.dateRange = {
      rangeStart: (dateStart ?? rangeEnd.subtract(DEFAULT_DATE_RANGE_DAYS, 'day')).toISOString(),
      rangeEnd: rangeEnd.toISOString()
    };
  }
  if (user) filter.visitorIds = [user];
  if (device) filter.doorIds = [device];
  if (detail) filter.reason = detail;

  return Object.keys(filter).length > 0 ? filter : null;
};
